import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carolina Méndez',
  role: 'Instructora de Pilates Reformer',
  location: 'Buenos Aires, Argentina',
  quote: 'Recuperé mis domingos. Antes pasaba horas armando clases — ahora abro el kit y en 5 minutos tengo todo listo. Mis alumnas notaron la diferencia desde la primera semana.',
  initials: 'CM',
  color: '#8B6FBF'
}, {
  name: 'Lucía Fernández',
  role: 'Studio Owner — Mat & Reformer',
  location: 'Madrid, España',
  quote: 'Lo mejor que invertí este año. Las fichas clínicas me dieron seguridad para trabajar con alumnas con lesiones de columna. Ya no improviso, voy con un plan claro.',
  initials: 'LF',
  color: '#D4A574'
}, {
  name: 'Andrea Salas',
  role: 'Instructora certificada',
  location: 'Ciudad de México, México',
  quote: 'Pensé que era "otro PDF más", pero esto es otro nivel. Los 6 tomos están organizados por objetivo y nivel — encuentro lo que necesito al instante.',
  initials: 'AS',
  color: '#0F8B6F'
}, {
  name: 'Valentina Rojas',
  role: 'Instructora de Pilates Clínico',
  location: 'Santiago, Chile',
  quote: 'Mis clases tienen variedad real ahora. Las progresiones lógicas mantienen a mis alumnas motivadas y yo dejé de sentirme repetitiva. Vale 10 veces lo que cuesta.',
  initials: 'VR',
  color: '#D98AA8'
}, {
  name: 'María José Castro',
  role: 'Instructora & Fisioterapeuta',
  location: 'Bogotá, Colombia',
  quote: 'Los bloques para poblaciones especiales son oro puro. Trabajo con embarazadas y adultos mayores y por fin tengo material profesional confiable a mano.',
  initials: 'MC',
  color: '#8B6FBF'
}, {
  name: 'Sofía Aguirre',
  role: 'Instructora Reformer Avanzado',
  location: 'Lima, Perú',
  quote: 'Lo descargué un viernes y el lunes ya estaba dando clases nuevas. Compatible con tablet, así que lo llevo al studio sin imprimir nada. Súper práctico.',
  initials: 'SA',
  color: '#D4A574'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-227">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-228"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-229">
        <div className="text-center mb-10 sm:mb-14" data-id="element-230">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-231">
            ⭐ Testimonios reales
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-232">
            Lo que dicen las instructoras{' '}
            <span className="text-primary" data-id="element-233">que ya lo usan</span>.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-234">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-235">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-236">
              4.9/5 (+800 Reseñas Verificadas)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-237">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-238">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-239">
                "
              </span>

              <div className="text-[#E0A52E] text-sm mb-3" data-id="element-240">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-241">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-242">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-243">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-244">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-245">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-246">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-247">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-248">
          Más de{' '}
          <span className="text-primary font-bold" data-id="element-249">15.000 instructoras</span> en
          todo el mundo de habla hispana ya enseñan con MEGAPACK PILATES LISTO.
        </p>
      </div>
    </section>;
}